// context/LocationContext.js
import { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [latitude, setLatitude] = useState(localStorage.getItem("latitude"));
  const [longitude, setLongitude] = useState(localStorage.getItem("longitude"));

  useEffect(() => {
    if (!latitude || !longitude) {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const lat = pos.coords.latitude.toString();
            const lng = pos.coords.longitude.toString();
            setLatitude(lat);
            setLongitude(lng);
            localStorage.setItem("latitude", lat);
            localStorage.setItem("longitude", lng);
          },
          (err) => console.error("Geolocation error:", err)
        );
      }
    }
  }, [latitude, longitude]);

  return (
    <LocationContext.Provider value={{ latitude, longitude }}>
      {children}
    </LocationContext.Provider>
  );
};

// ✅ custom hook for easy usage
export const useGeoLocation   = () => useContext(LocationContext);
